<script lang="ts">
    import { getAccount, getLogin, getDealer, putAccountChangeRequest, postMail } from "../../api"

    import { contentFloater, requireLogin } from "../../helper"
    import { newNotification, removeNotification } from "../../store"
    import MiniLoader from "../widgets/MiniLoader.svelte"
    import Icon from "../widgets/Icon.svelte"
    import { mdiInformationOutline } from "@mdi/js"
    import Checkbox from "../widgets/Checkbox.svelte"
    import { _ } from "svelte-i18n"
    import { initialLocale } from "../../i18n"

    export let lang = "de"

    // @ts-ignore
    let account: Account = {}
    // @ts-ignore
    let dealer: Dealer = {}

    let requestForSubAccount: any = {}

    $: a = account.changeRequest?.account || account
    $: d = account.changeRequest?.dealer || dealer

    $: inProgress = !!account.changeRequest?.account

    async function load() {
        try {
            const _l = await getLogin()
            const { dealerNumber, personNumber } = _l?.tokenData?.ident
            if (dealerNumber && personNumber) {
                // @ts-ignore
                account =
                    (
                        await getAccount({
                            _id: _l?.tokenData?.id,
                        })
                    ).data[0] || {}
                // @ts-ignore
                dealer = (await getDealer({ number: dealerNumber })).data[0] || {}
            }
        } catch (e) {
            requireLogin()
        }
    }

    let notif: NotificationEntry

    let changeLoading = false
    function submitChangeRequest() {
        changeLoading = true
        removeNotification(notif)

        putAccountChangeRequest(d, a)
            .then(() => {
                notif = newNotification({
                    class: "success",
                    html: $_("account.requestForwarded"),
                })
                // @ts-ignore
                account = {}
                // @ts-ignore
                dealer = {}
                load()
            })
            .catch((e) => {
                console.log(e)
                notif = newNotification({
                    class: "error",
                    html: $_("account.errorOccurred"),
                    timeout: 10000,
                    removeOnNewLocation: true,
                })
            })
            .finally(() => {
                changeLoading = false
            })
    }

    let requestLoading = false
    function submitRequestAccount() {
        requestLoading = true
        removeNotification(notif)

        postMail("requestForSubAccount", requestForSubAccount)
            .then(() => {
                notif = newNotification({
                    class: "success",
                    html: $_("account.requestForwarded"),
                })
                requestForSubAccount = {}
            })
            .catch((e) => {
                console.log(e)
                // shows error via postMail
            })
            .finally(() => {
                requestLoading = false
            })
    }

    load()
</script>

<section id="login" class="section_padding" data-lang="{lang}">
    <div class="container">
        {#if account?.id}
            <!-- Kundenstamm Änderungen -->
            <h1>{$_("account.customerBase")}</h1>
            <form style="margin-bottom:40px;" on:submit|preventDefault="{submitChangeRequest}">
                <h3>{$_("account.customerNumber")}: {account.ident?.dealerNumber}</h3>
                <input
                    type="text"
                    placeholder="{$_('account.company')}"
                    bind:value="{d.company}"
                    disabled="{inProgress}"
                    required
                />
                <input
                    type="text"
                    placeholder="{$_('account.streetAndHouseNumber')}"
                    bind:value="{d.street}"
                    disabled="{inProgress}"
                    required
                />
                <div class="row">
                    <div class="col-md-6 no-padding-left">
                        <input
                            type="text"
                            placeholder="{$_('account.postcode')}"
                            bind:value="{d.postcode}"
                            disabled="{inProgress}"
                            required
                        />
                    </div>
                    <div class="col-md-6 no-padding-right">
                        <input
                            type="text"
                            placeholder="{$_('account.city')}"
                            bind:value="{d.city}"
                            disabled="{inProgress}"
                            required
                        />
                    </div>
                </div>
                <input
                    type="text"
                    placeholder="{$_('account.country')}"
                    bind:value="{d.countryCode}"
                    disabled="{inProgress}"
                    required
                />

                <h3>{$_("account.accessNumber")}: {account.ident?.personNumber}</h3>
                <div class="row">
                    <div class="col-md-6 no-padding-left">
                        <input
                            type="text"
                            placeholder="{$_('account.salutation')}"
                            bind:value="{a.salutation}"
                            disabled="{inProgress}"
                            required
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding-left">
                        <input
                            type="text"
                            placeholder="{$_('account.firstname')}"
                            bind:value="{a.firstname}"
                            disabled="{inProgress}"
                            required
                        />
                    </div>
                    <div class="col-md-6 no-padding-right">
                        <input
                            type="text"
                            placeholder="{$_('account.lastname')}"
                            bind:value="{a.lastname}"
                            disabled="{inProgress}"
                            required
                        />
                    </div>
                </div>
                <input
                    type="text"
                    placeholder="{$_('account.position')}"
                    bind:value="{a.position}"
                    disabled="{inProgress}"
                    required
                />
                <input
                    type="email"
                    placeholder="{$_('account.email')}"
                    bind:value="{a.email}"
                    disabled="{inProgress}"
                    required
                />
                <input type="text" placeholder="{$_('account.phone')}" bind:value="{a.phone}" disabled="{inProgress}" />
                <input
                    type="text"
                    placeholder="{$_('account.mobilePhone')}"
                    bind:value="{a.mobilePhone}"
                    disabled="{inProgress}"
                />
                <input type="text" placeholder="{$_('account.fax')}" bind:value="{a.fax}" disabled="{inProgress}" />

                {#if !inProgress}
                    <!-- Checkbox durch Komponente tauschen ! -->
                    <div class="inputholder">
                        <Checkbox required="{true}" label=" ">
                            <span>
                                {$_("account.termsAndConditionsRead1")}
                                <a href="/{initialLocale}/datenschutz" use:contentFloater
                                    >{$_("account.privacyPolicy")}</a
                                >{$_("account.termsAndConditionsRead2")}
                            </span>
                        </Checkbox>
                    </div>

                    <div style="display:flex; justify-content: flex-end;">
                        {#if changeLoading}
                            <MiniLoader />
                        {:else}
                            <button class="btn" type="submit">{$_("account.submitChangeRequest")}</button>
                        {/if}
                    </div>
                {/if}
            </form>
            {#if inProgress}
                <!-- Optionale Info -->
                <div class="redinfo">
                    <Icon path="{mdiInformationOutline}" size="24px" />
                    {$_("account.changeRequestInProgress")}
                </div>
            {/if}

            <h1>{$_("account.unlockColleague")}</h1>
            <form
                style="margin-bottom:40px;"
                on:submit|preventDefault="{submitRequestAccount}"
                data-cy="unlock-coworker"
            >
                <div class="row">
                    <div class="col-md-6 no-padding-left">
                        <input
                            type="text"
                            placeholder="{$_('account.salutation')}"
                            bind:value="{requestForSubAccount.salutation}"
                            required
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding-left">
                        <input
                            type="text"
                            placeholder="{$_('account.firstname')}"
                            bind:value="{requestForSubAccount.firstname}"
                            required
                        />
                    </div>
                    <div class="col-md-6 no-padding-right">
                        <input
                            type="text"
                            placeholder="{$_('account.lastname')}"
                            bind:value="{requestForSubAccount.lastname}"
                            required
                        />
                    </div>
                </div>
                <input
                    type="text"
                    placeholder="{$_('account.position')}"
                    bind:value="{requestForSubAccount.position}"
                    required
                />
                <input
                    type="email"
                    placeholder="{$_('account.email')}"
                    bind:value="{requestForSubAccount.email}"
                    required
                />
                <input type="text" placeholder="{$_('account.phone')}" bind:value="{requestForSubAccount.phone}" />
                <input
                    type="text"
                    placeholder="{$_('account.mobilePhone')}"
                    bind:value="{requestForSubAccount.mobilePhone}"
                />
                <input type="text" placeholder="{$_('account.fax')}" bind:value="{requestForSubAccount.fax}" />

                <div class="inputholder">
                    <Checkbox required="{true}" label=" ">
                        <span>
                            {$_("account.iAccept")}
                            <a href="/{initialLocale}/datenschutz" use:contentFloater>{$_("account.privacyPolicy")}</a>
                            {$_("account.haveRead")}
                        </span>
                    </Checkbox>
                </div>

                <div style="display:flex; justify-content: flex-end;">
                    {#if requestLoading}
                        <MiniLoader />
                    {:else}
                        <button class="btn" type="submit">{$_("account.request")}</button>
                    {/if}
                </div>
            </form>
        {:else}
            <br /><br />
            <MiniLoader />
        {/if}
    </div>
</section>
